import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=c6d2ae20"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/cpcic-admin-release/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d2ae20')) {
      api.createRecord('c6d2ae20', component.options)
    } else {
      api.reload('c6d2ae20', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=c6d2ae20", function () {
      api.rerender('c6d2ae20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/basic-layout/menu-side/menu-item.vue"
export default component.exports